<script lang="ts">
	export let checkedFill = "#729cfc";
	export let circlePathId = "";
	export let checkPathId = "";
	export let id = "";

	export let value: any;
	export let group: any;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
	{#if group === value}
		<path
			style={`fill:${checkedFill}`}
			data-name="패스 58"
			class="Checked"
			d="M200.422 278.475a15 15 0 1 0 15 15 15 15 0 0 0-15-15zm8.31 9.486-9.7 11.79a.6.6 0 0 1-.924 0l-5.994-7.284a.594.594 0 0 1 .084-.84.606.606 0 0 1 .846.078l5.526 6.72 9.24-11.226a.6.6 0 1 1 .924.762z"
			transform="translate(-185.422 -278.475)" />
	{:else}
		<path
			data-name="패스 60"
			id={circlePathId}
			class="Circle"
			d="M270.422 278.475a15 15 0 1 0 15 15 15 15 0 0 0-15-15zm0 28.8a13.8 13.8 0 1 1 13.8-13.8 13.817 13.817 0 0 1-13.8 13.8z"
			transform="translate(-255.422 -278.475)" />
		<path
			data-name="패스 61"
			id={checkPathId}
			class="CheckPath"
			d="M273.225 306.205a.626.626 0 0 1-.483-.229l-6.253-7.6a.626.626 0 1 1 .967-.8l5.769 7.011 9.644-11.72a.626.626 0 1 1 .967.8l-10.128 12.307a.626.626 0 0 1-.483.231z"
			transform="translate(-260.161 -284.427)" />
	{/if}
</svg>
<input
	id={id}
	type="radio"
	value={value}
	on:change
	style={'display : none'}
	bind:group />

<style lang="scss">
	svg {
		cursor: pointer;
		&:hover {
			.Circle {
				fill: #9dafc6;
			}
			.CheckPath {
				fill: #9dafc6;
			}
			.Checked {
				fill: #729cfc;
			}
		}
	}
	.Checked {
		fill: #6591fa;
		transition: fill 0.15s;
	}

	.Circle,
	.CheckPath {
		fill: #bcbfc3;
		transition: fill 0.15s;
	}

</style>
